import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { signUp } from "../api/auth";

function Signup() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError("");

        if (password !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        try {
            const response = await signUp({ email, password, confirmPassword });
            console.log("Sign up successful", response);
            if (response.authToken) {
                 const params = new URLSearchParams(window.location.search);
                 const redirectUrl = params.get('redirect');

                 if (redirectUrl) {
                     window.location.href = `${redirectUrl}?token=${response.authToken}`;
                 } else {
                     navigate("/signin");
                 }
            } else if (response.success) {
                 navigate("/signin");
            }
        } catch (err: any) {
            console.log("Authentication failed", err);
            setError("Registration failed. Please try again.");
        }
    };

    return (
        <div className="auth-container">
            <h2>Sign Up</h2>
             {error && <p style={{ color: 'red' }}>{error}</p>}
            <form onSubmit={handleSubmit}>
                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <input
                    type="password"
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                />
                <button type="submit">Sign Up</button>
            </form>
            <p style={{ textAlign: "center", marginTop: "1rem" }}>
                Already have an account? <Link to="/signin">Sign In</Link>
            </p>
        </div>
    );
}

export default Signup;